import React from "react";
import { Github, Instagram, Linkedin, Mail, Twitter } from "lucide-react";
import { buildWhatsAppLink } from "@/lib/whatsapp";
import TID from "@/lib/testIds";

const year = new Date().getFullYear();

const cols = [
  {
    title: "Quick Links",
    links: [
      { label: "Home", href: "#home" },
      { label: "Services", href: "#services" },
      { label: "Why Us", href: "#why-us" },
      { label: "Testimonials", href: "#testimonials" },
      { label: "FAQ", href: "#faq" },
      { label: "Contact", href: "#contact" },
    ],
  },
  {
    title: "Services",
    links: [
      { label: "Penetration Testing", href: "#services" },
      { label: "API Security", href: "#services" },
      { label: "Vulnerability Assessment", href: "#services" },
      { label: "Meta & Google Ads", href: "#services" },
      { label: "SEO & Content", href: "#services" },
      { label: "Website Development", href: "#services" },
    ],
  },
];

export const Footer = () => {
  return (
    <footer
      data-testid={TID.footer}
      className="relative bg-[#0B1120] text-slate-300"
    >
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-brand-blue/40 to-transparent" />
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-2.5">
            <img
              src="/assets/naksec-logo.png"
              alt="Naksec"
              className="w-10 h-10 object-contain"
            />
            <div className="font-display text-lg font-bold tracking-tight text-white">
              Naksec
            </div>
          </div>
          <p className="mt-5 text-slate-400 leading-relaxed max-w-md text-sm">
            Premium penetration testing and growth marketing for ambitious teams.
            Built on craft, transparency, and measurable outcomes.
          </p>
          <div className="mt-6 flex items-center gap-3">
            {[
              { Icon: Twitter, href: "#", label: "Twitter" },
              { Icon: Linkedin, href: "#", label: "LinkedIn" },
              { Icon: Instagram, href: "#", label: "Instagram" },
              { Icon: Github, href: "#", label: "GitHub" },
            ].map(({ Icon, href, label }) => (
              <a
                key={label}
                href={href}
                aria-label={label}
                className="w-10 h-10 rounded-full border border-white/10 inline-flex items-center justify-center hover:bg-white/5 hover:border-white/30 transition"
              >
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        {cols.map((c) => (
          <div key={c.title} className="lg:col-span-2">
            <h4 className="font-display text-sm font-semibold text-white uppercase tracking-wider">
              {c.title}
            </h4>
            <ul className="mt-5 space-y-3">
              {c.links.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    className="text-sm text-slate-400 hover:text-white transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div className="lg:col-span-3">
          <h4 className="font-display text-sm font-semibold text-white uppercase tracking-wider">
            Contact
          </h4>
          <ul className="mt-5 space-y-3 text-sm">
            <li className="flex items-center gap-2 text-slate-300">
              <Mail className="w-4 h-4 text-brand-blue" />
              <a
                href={`mailto:${process.env.REACT_APP_COMPANY_EMAIL || "contact@naksec.com"}`}
                className="hover:text-white"
              >
                {process.env.REACT_APP_COMPANY_EMAIL || "contact@naksec.com"}
              </a>
            </li>
            <li>
              <a
                href={buildWhatsAppLink()}
                target="_blank"
                rel="noopener noreferrer"
                className="text-emerald-400 hover:text-emerald-300"
              >
                WhatsApp us →
              </a>
            </li>
            <li className="text-slate-400">Mon–Sat · 10:00 – 19:00 IST</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-wrap items-center justify-between gap-4 text-xs text-slate-400">
          <p>© {year} Nikhil Digital Solutions. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <a data-testid={TID.footerPrivacy} href="#" className="hover:text-white">Privacy Policy</a>
            <a data-testid={TID.footerTerms} href="#" className="hover:text-white">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
